const RecentNotReply = () =>
  import('@/views/main/wechatMgmt/recentNotReply/RecentNotReply.vue')
export default {
  path: '/main/wechatMgmt/recentNotReply',
  name: 'RecentNotReply',
  component: RecentNotReply
}
